import consentCheck from '@capsule/consent-check'
import generateScriptElement from '@capsule/generate-script-element'

export default class Parsely {
	private script: string | null

	constructor() {
		const scriptElement = document.querySelector('#parsely-script')
		this.script = scriptElement ? scriptElement.getAttribute('data-src') : null
	}

	init() {
		consentCheck('allConsentGiven', () => {
			if (this.script) {
				const parselyScript = generateScriptElement({
					src: this.script
				})

				document.head.appendChild(parselyScript)
			}
		})
	}
}
